import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {kanExpansionPanel} from "./components/expansion-panel/component";
import {MatButtonModule, MatDialogModule, MatIconModule} from "@angular/material";
import {TranslateModule} from "@ngx-translate/core";
import {kanUppercase} from "./directives/uppercase";
import {kanRemoveDialog} from "./dialogs/remove-dialog/component";
import {CKEditorModule} from "ng2-ckeditor";
import {kanEditor} from "./components/editor/component";
import {FormsModule} from "@angular/forms";
import {KanHighlightPipe} from "./pipes/highlight";

@NgModule({
    declarations: [
        kanExpansionPanel,
        kanRemoveDialog,
        kanUppercase,
        kanEditor,
        KanHighlightPipe
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        CKEditorModule
    ],
    exports: [
        kanExpansionPanel,
        kanUppercase,
        kanRemoveDialog,
        kanEditor,
        KanHighlightPipe
    ],
    entryComponents: [
        kanRemoveDialog
    ],
    providers: [],
    bootstrap: []
})
export class kanCommonModule {
}



// WEBPACK FOOTER //
// ./src/modules/common/module.ts